module.exports = __webpack_public_path__ + "media/22.5fa0c16a.mp3";